// detailSlice.js

const CONDITION_RANK = {
  "All New":               0,
  "Certified Refurbished": 1,
  "Pre-Owned Top":         2,
  "Pre-Owned":             3,
}

export default (set, get) => ({
  currentProduct:      null,
  variants:            [],
  currentRelatedItems: [],
  currentAccessories:  [],
  // selectedVariant:      {},

  setCurrentProduct: (slug) => {
    const {
      allProducts,
      fullProducts,
      variantsData,
      relatedItems,
      accessories,
    } = get()

    const base = allProducts.find(p => p.slug === slug)
    const full = fullProducts.find(
      f => f.slug === slug || f.id === (base?.id || slug)
    ) || {}

    const prod = {
      ...base,
      ...full,
      specs:       full.specs       || [],
      keyFeatures: full.keyFeatures || [],
      videos:      full.videos      || [],
    }

    const productId = prod.id || slug
    const vs = variantsData
      .filter(v => v.productId === productId)
      .sort(
        (a, b) =>
          (CONDITION_RANK[a.condition] || 99) -
          (CONDITION_RANK[b.condition] || 99)
      )

    const relatedObjs = (relatedItems[productId] || [])
      .map(id => fullProducts.find(p => p.slug === id || p.id === id))
      .filter(Boolean)

    const acc = (accessories[productId] || [])
      .map(id => allProducts.find(p => p.slug === id || p.id === id))
      .filter(Boolean)

    set({
      currentProduct:      prod,
      variants:            vs,
      currentRelatedItems: relatedObjs,
      currentAccessories:  acc,
      selectedVariant:      {},   // reset selection when product changes
    })
  },

  setSelectedVariant: (variant) => {
    // console.log("🛠️ setSelectedVariant called with:", variant)

    // Replace the whole object in state
    set(() => ({
      selectedVariant: { ...variant }
    }))
  },
})